export default __webpack_public_path__ + "static/PoweredbyDomainInsight_Logo_RGB-GREEN-c6f3e42eddcb1b19272729f3f104d17c.png";